<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-search">
        <el-form ref="formData" :model="formData" :inline="true" label-width="100px" class="formInline" size="mini">
          <el-form-item label="项目编号" prop="projectCode">
            <el-input v-model="formData.projectCode" placeholder="请输入项目编号..."></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="formData.projectName" placeholder="请输入项目名称..."></el-input>
          </el-form-item>
          <el-form-item label="配置状态" prop="status">
            <el-select v-model="formData.status" placeholder="请选择配置状态">
              <el-option label="不限" :value="null"></el-option>
              <el-option label="已配置" value="1"></el-option>
              <el-option label="未配置" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户名称" prop="customer">
            <el-select v-model="formData.customer" filterable placeholder="请选择客户名称...">
              <el-option label="不限" :value="null"></el-option>
              <el-option v-for="item in allCustomers" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签约平台" prop="supplier">
            <el-select v-model="formData.supplier" filterable placeholder="请选签约平台应商...">
              <el-option label="不限" :value="null"></el-option>
              <el-option :label="item" :value="item" v-for="item in serviceSuppliers"
                           :key="item"></el-option>
              <!-- <el-option label="众简" :value="'众简'"></el-option>
              <el-option label="薪太软" :value="'薪太软'"></el-option>
              <el-option label="博尔捷" :value="'博尔捷'"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="修改人" prop="updater">
            <el-input v-model="formData.updater" placeholder="请输入修改人..."></el-input>
          </el-form-item>
          <el-form-item label="项目开始日期" prop="startDate">
            <el-date-picker
                v-model="formData.startDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            <!-- <el-input v-model="formData.startDate" placeholder="请输入修改人..."></el-input> -->
          </el-form-item>
          <el-form-item label="项目结束日期" prop="endDate">
            <!-- <el-input v-model="formData.endDate" placeholder="请输入修改人..."></el-input> -->
            <el-date-picker
                v-model="formData.endDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
          <hr style="margin-bottom: 9px;">
          <div class="slide-btns clearfix">
            <el-form-item style="position: relative ;">
              <el-button type="text" class="reset-btn" @click="resetForm">清空</el-button>
              <el-button class="search-btn" @click="submitForm">筛选</el-button>
              <el-button class="search-btn" @click="exportProject">导出</el-button>
              <div style="display: inline-block;position: absolute; right:-150% ;">
                <el-button type="primary" size="mini" round @click="exportProjectCategory">未配置清单下载</el-button>
              </div>
              
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table :data="tableData" size="small" v-loading="listLoading" element-loading-text="拼命加载中" border
                  style="width: 100%" header-row-class-name="table-header">
          <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
          <el-table-column prop="projectCode" label="项目编号" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
          <el-table-column prop="serviceNm" label="服务商" align="center"></el-table-column>
          <el-table-column prop="customer" label="客户名称" align="center"></el-table-column>
          <el-table-column prop="startTime" label="项目开始时间" align="center"></el-table-column>
          <el-table-column prop="endTime" label="项目结束时间" align="center"></el-table-column>
          <el-table-column prop="status" label="配置状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">已配置</span>
              <span v-else>未配置</span>
            </template>
          </el-table-column>
          <el-table-column prop="supplier" label="签约平台" align="center"></el-table-column>
          <el-table-column prop="secSupplier" label="落地方" align="center"></el-table-column>
          <el-table-column prop="supplierBeginDate" label="落地方开始日期" align="center"></el-table-column>
          <el-table-column prop="supplierEndDate" label="落地方结束日期" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间" align="center"></el-table-column>
          <el-table-column prop="updaterAccount" label="修改人账号" align="center"></el-table-column>
          <el-table-column prop="updaterNick" label="修改人姓名" align="center"></el-table-column>
          <el-table-column v-if="editProjectAuth" label="操作" align="center">

            <template slot-scope="scope">
              <span style="color: #1652ff; cursor: pointer;"
                    @click="openEditDialog(scope.row.id, scope.row.projectName, scope.row.supplier)">修改</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="formData.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>
    <el-dialog :title="editProjectName" :visible.sync="showEditDialog" width="30%" center>
      <hr style="margin-bottom: 9px">
      <div style="text-align: center; margin-top: 50px;">
        <el-select v-model="selectSupplier" placeholder="请选择供应商" style="width: 100%;">
          <el-option label="无" :value="null"></el-option>
          <!-- <el-option label="众简" value="众简"></el-option>
          <el-option label="薪太软" value="薪太软"></el-option>
          <el-option label="博尔捷" value="博尔捷"></el-option> -->
          <el-option :label="item" :value="item" v-for="item in serviceSuppliers"
                           :key="item"></el-option>
        </el-select>
        <div style="text-align:center;margin-top:30px;">
          <el-button class="search-btn" @click="editProjectSupplier">确定</el-button>
          <el-button class="search-btn" @click="showEditDialog=false">取消</el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import utils from '../../common/js/util.js'
    import moment from "moment";
  export default {
    data() {
      return {
        allCustomers: [],
        formData: {
          pageNo: 1,
          pageSize: 10,
          projectCode: null,
          projectName: null,
          status: null,
          customer: null,
          supplier: null,
          updater: null,
          startDate: null,
          endDate: null
        },
        tableData: [],
        total: null,
        listLoading: false,
        editProjectId: null,
        editProjectName: null,
        showEditDialog: false,
        editProjectAuth: false,
        selectSupplier: null,
        serviceSuppliers: []
      }
    },
    mounted() {
      this.getEditProjectAuth();
      this.searchAllCustomer();
      this.getData();
      this.getServiceSuppliers();
    },
    methods: {
      getData() {
        this.listLoading = true;
        if(this.formData.startDate){
          this.formData.startDate = this.computeDate(this.formData.startDate)
        }
        if(this.formData.endDate){
          this.formData.endDate = this.computeDate(this.formData.endDate)
        }
         console.log('this.formData',this.formData);
        this.$http({
          method: 'GET',
          url: '/rest/project/list',
          params: this.formData
        }).then(res => {
          this.tableData = res.data.items;
          this.total = res.data.totalItemsCount;
          this.listLoading = false;
        }).catch(err => {
          this.listLoading = false;
        })
      },
      searchAllCustomer() {
        this.$http({
          method: 'GET',
          url: '/rest/baseCenter/all-customers'
        }).then(res => {
          this.allCustomers = res.data.data
        }).catch(err => {
        })
      },
      resetForm() {
        this.$refs['formData'].resetFields();
      },
      submitForm() {
        this.formData.pageSize = 10;
        this.formData.pageNo = 1;
        this.getData();
      },
      exportProject(){
        this.listLoading = true;
        this.$http({
          method:"GET",
          url:"/rest/project/export",
          params:this.formData,
        }).then(res=>{
          console.log(res.data);
          location.href = utils.returnUrlHead() + res.data.message;
          this.listLoading = false;
        }) .catch((error) => {
          this.listLoading = false;
          this.$alert("导出错误，请联系管理员！");
        });
      },
      exportProjectCategory(){
        this.$http({
          method:"GET",
          url:"/rest/projectCategory/export",
          params:{},
        }).then(res=>{
          location.href = utils.returnUrlHead() + res.data.data;
          this.listLoading = false;
        })
      },
      handleSizeChange(val) {
        this.formData.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val;
        this.getData();
      },
      openEditDialog(projectId, projectName, supplier) {
        this.editProjectId = projectId;
        this.editProjectName = projectName;
        this.showEditDialog = true;
        if(supplier != '--') {
          this.selectSupplier = supplier;
        } else {
          this.selectSupplier = null;
        }
      },
      getEditProjectAuth() {
        this.$http({
          method: 'GET',
          url: '/rest/project/edit-auth',
          params: {
            userId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          this.editProjectAuth = res.data.data
        }).catch(err => {
        })
      },
      editProjectSupplier() {
        this.$http({
          method: 'POST',
          url: '/rest/project/edit',
          data: {
            id: this.editProjectId,
            supplier: this.selectSupplier,
            updater: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          this.showEditDialog = false;
          utils.myNotify(this, "success", res, '操作成功');
          this.getData();
        }).catch(err => {
          utils.myNotify(this, "error", res, '操作失败');
        })
      },
      getServiceSuppliers() {
        this.$http({
          method: 'GET',
          url: '/rest/JiangYiJoint/getServiceSuppliers',
          
        }).then(res => {
          this.serviceSuppliers = res.data
        }).catch(err => {
        })
      },
      computeDate(date){
        return moment(date).format("YYYY-MM-DD");
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-btn {
    margin-left: 30px;
    margin-right: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/views/personnelCenter/projectConfig.vue